<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
  },
  computed: {
    svgSrc() {
      return this.iconUrl(this.name + '.svg')
    }
  },
};
</script>

<template>
  <img :src="svgSrc" />
</template>
